module.exports = __webpack_public_path__ + "static/shantanu-fc433ea73086f44822029e6950508d29.jpeg";